// src/hooks/useCancelSinister.ts
import { useState } from "react";
import * as yup from "yup";
import { useToast } from "../../../shared/hooks";
import { SinisterService } from "../../../shared/services/api/sinister/SinisterService";
import { ToastContent } from "../../../shared/components";

interface Params {
	id: string;
	schema: yup.AnyObjectSchema;
	onSuccess?: () => void;
	setFormErrors?: (errors: Record<string, string>) => void;
}

export const useCancelSinister = ({ id, schema, onSuccess, setFormErrors }: Params) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isUploading, setIsUploading] = useState(false);
	const toastHandler = useToast();

	const handleCancel = async (data: { canceledReason: string; canceledObs?: string }) => {
		setIsLoading(true);
		setIsUploading(true);

		try {
			const validated = await schema.validate(data, { abortEarly: false });

			await SinisterService.cancelSinister(id, validated);

			toastHandler.present({
				type: "success",
				position: "top-right",
				messageOrContent: <ToastContent title="Sucesso" content="Sinistro cancelado com sucesso" />,
			});

			onSuccess?.();
		} catch (err: any) {
			if (err.name === "ValidationError" && setFormErrors) {
				const validationErrors: Record<string, string> = {};
				err.inner.forEach((error: yup.ValidationError) => {
					if (error.path) validationErrors[error.path] = error.message;
				});
				setFormErrors(validationErrors);
			} else {
				toastHandler.present({
					type: "error",
					position: "top-center",
					messageOrContent: err?.message ?? "Erro ao cancelar sinistro",
				});
			}
		} finally {
			setIsLoading(false);
			setIsUploading(false);
		}
	};

	return {
		handleCancel,
		isLoading,
		isUploading,
	};
};
